import { ADVISOR_ENGAGEMENT_FRAGMENT } from '@src/gql/fragments/AdvisorEngagementFragment'
import { ScoAdvisorEngagement } from '@src/graphql-types'
import { gql } from '@src/lib/gql'

export type AdvisorBoardQueryData = {
  advisorBoard?: Array<ScoAdvisorEngagement | null> | null
}

/** Type guard: drop null/undefined rows from advisorBoard. */
export function filterEngagements(board?: Array<ScoAdvisorEngagement | null> | null): ScoAdvisorEngagement[] {
  return (board || []).filter((e): e is ScoAdvisorEngagement => !!e)
}

export const ADVISOR_BOARD = gql`
  query AdvisorBoard {
    advisorBoard {
      ...AdvisorEngagementFragment
    }
  }
  ${ADVISOR_ENGAGEMENT_FRAGMENT}
`
